import Styles from "./styles/viewCard.module.css";


const ViewCard = ({cardHeader,cardContent}) => {
  return (
    <div className={Styles.cardBody}>
         <div className={Styles.cardHeader}>
{cardHeader}
         </div>
             <div className={Styles.cardContent}>
{cardContent?cardContent:"NA"}
             </div>
    </div>
  )
}

export default ViewCard